import React from 'react'
import MyForm  from "../Components/Scholarship/scholarshipForm"
import {Center,Box,Text,VStack,Divider,Image} from '@chakra-ui/react'
import NavBar from "../Components/Navb"
import Footer from '../Components/Footer';

function Scholarship() {
  return (
    <>
    <NavBar/>
    <Box backgroundImage="url('https://t4.ftcdn.net/jpg/01/96/87/57/360_F_196875700_4rLgO7QPC1lmtTny5VOceDY80DJasArn.jpg')"
      backgroundSize="cover"
      backgroundPosition="center" pb="100px">
    <Center  >
    <VStack>
    <Text fontSize='3xl' fontWeight={"bold"} fontFamily={"Arvo"} color={"yellow.400"}>Scholarship Registration</Text>
    <Divider
            w={["70px", "300px", "400px"]}
            h="10px"
            color="white"
            bgColor="white"
            mt="0Px"
          />
    <Box bg="white" w={["90vw", "90vw", "80vw"]} border='1px' borderColor='gray.200' rounded={"xl"} boxShadow='dark-lg' >
    <Center>
     <MyForm />
     </Center>
     </Box>
     </VStack>
    </Center>
    </Box>
    <Footer/>
    </>
  )
}

export default Scholarship